<template>
  <ChecklistModal
    :title="options.title || $tc('tag', 2)"
    :value="valueComp"
    @input="updateFilter"
    :items="fetchTags"
    :compare="(a, b) => a === b"
    :transform="item => ({ value: item, label: options.i18nPrefix ? $t(`${options.i18nPrefix}:${item}`) : item })"
  >
    <template #input="{ items }">
      <div class="elder-input">
        <label class="elder-input__label">{{ options.title || $tc('tag', 2) }}</label>
        <ButtonComponent class="elder-input__wrapper" :icon="['fal', 'tags']" icon-placement="left">
          <template #label>
            <span v-html="getLabel(items)"></span>
            <Badge class="ml-1" v-if="valueComp.length > limit" :value="`+ ${valueComp.length - limit}`" />
            <FontAwesomeIcon class="ml-1" :icon="['fal', 'angle-down']" size="lg" />
          </template>
        </ButtonComponent>
      </div>
    </template>
  </ChecklistModal>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import ChecklistModal from '@/components/Select/ChecklistModal'
import Badge from '@/components/Badge'

export default {
  props: {
    value: null,
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      limit: 1,
    }
  },
  computed: {
    valueComp() {
      return this.value instanceof Array ? this.value : [this.value].filter(Boolean)
    },
  },
  methods: {
    getLabel(items) {
      if (!items.length) return this.options.title || this.$tc('tag', 2)
      let firstSelected = items.slice(0, this.limit).join(', ')
      return this.options.i18nPrefix ? this.$t(`${this.options.i18nPrefix}:${firstSelected}`) : firstSelected
    },
    fetchTags() {
      if (this.options.items instanceof Array) return this.options.items
      return fetch(this.options.items).then(res => res.json())
    },
    updateFilter(value) {
      this.$emit('input', value)
    },
  },
  components: {
    ChecklistModal,
    ButtonComponent,
    Badge,
  },
}
</script>
